import { type FC, type ReactNode } from 'react';
import { Modal } from 'react-bootstrap';

interface Props {
	isShown: boolean;
	title: ReactNode;
	children: ReactNode;
	footer: ReactNode;
	onHide: () => void;
	modalStyles?: string;
}

const ModalWindow: FC<Props> = (props) => {
	const { isShown, title, children, footer, onHide, modalStyles } = props;

	return (
		<Modal show={isShown} onHide={onHide} dialogClassName={modalStyles} centered>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{children}</Modal.Body>
			<Modal.Footer>{footer}</Modal.Footer>
		</Modal>
	);
};

export default ModalWindow;
